import { Container } from "./style";

import { Layout } from "../../components/Layout";
import { Button } from "../../components/Button";

import CellphoneImg from "../../assets/img/cellphones-2.png";

import { CaretLeft } from "phosphor-react";

import { useNavigate, useParams } from "react-router-dom";

import { useTranslation } from 'react-i18next'
import LanguageSelector from "../../components/LanguageSelector";

export const Error = () => {
  const navigate = useNavigate();
  const { language } = useParams();
  const { t } = useTranslation();

  const handleApp = () => {
    window.open(
      "https://smartfitapp.page.link/4cqW",
      "_blank"
    );
  };

  return (
    <>
      <Layout>
        <Container>
          <div className="topBar">
            <div className="btn-back" onClick={() => navigate(`/${language}`)}>
              <i>
                <CaretLeft />
              </i>
              <p>{t('errorPage.backbutton')}</p>
            </div>
          </div>
          <div className="error">
            <h1>
              {t('errorPage.header')}
            </h1>
            <p>
              {t('errorPage.subtitle')}
            </p>
            <p>
              {t('errorPage.download')}
            </p>
          </div>
          <div className="error-app">
            <Button label={t('errorPage.action').toUpperCase()} evt={handleApp} />
            <figure>
              <img src={CellphoneImg} alt="" />
            </figure>
          </div>

          <LanguageSelector />
        </Container>
      </Layout>
    </>
  );
};
